(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('BackgroundReportsService', BackgroundReportsService);

  BackgroundReportsService.$inject = ['$resource'];

  function BackgroundReportsService ($resource) {
    return $resource(apiUrl + '/reports/background-reports/:id', { id: '@id' }, {
      checkAllowed: {
        url: apiUrl + '/reports/background-reports/checkAllowed',
        method: 'GET',
        params: {},
        isArray: false
      },
      getSchedulings: {
        url: apiUrl + '/reports/background-reports',
        method: 'GET',
        params: {},
        isArray: false
      },
      delete: {
        url: apiUrl + '/reports/background-reports',
        method: 'POST',
        params: {},
        isArray: false
      },
      checkPeriod: {
        url: apiUrl + '/reports/background-reports/checkPeriod',
        method: 'GET',
        params: {},
        isArray: false
      }
    });
  }
})();
